







































































import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user.store";
import { UserEntity } from "@/models/userEntity";
import { PartnerModule } from "@/store/modules/partner";
import ThePartnerSelectorList from "@/layouts/navigation/ThePartnerSelectorList.vue";

@Component({
  components: { ThePartnerSelectorList }
})
export default class ProfileMenu extends Vue {
  logout() {
    this.$router.push({ name: "Logout" });
  }

  get partner() {
    return PartnerModule.partner;
  }

  get displayPartnerName() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return false;
      case "sm":
        return false;
      case "md":
        return true;
      case "lg":
        return true;
      case "xl":
        return true;
    }
    return false;
  }

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get user(): UserEntity {
    return UserModule.user;
  }

  get logOut() {
    const item = {
      icon: "mdi-logout",
      text: "Logout",
      link: "/login/logout"
    };
    return item;
  }

  async performLogout() {
    await UserModule.logout();
  }

  get userItem() {
    const item = {
      icon: "mdi-account-outline",
      text: "Profil",
      link: "/profile"
    };
    return item;
  }
}
